import {Link, styled} from "@mui/material"

const StandardMyAccountUsernameLinkContainer = styled(Link)(() => ({
    alignItems: "center",
    flexDirection: "row",
    textTransform: "capitalize",
    display: "flex",
    height: "100%",
    width: "100%",
    justifyContent: "center",
    textDecoration: "none",
}))

StandardMyAccountUsernameLinkContainer.displayName = "StandardMyAccountUsernameLinkContainer"

export default StandardMyAccountUsernameLinkContainer
